import {
  //
  GET_PRE_DATA,
  GET_PRE_DATA_FAILURE,
  GET_PRE_DATA_SUCCESS,
  //
  SAVE_PRE,
  SAVE_PRE_FAILURE,
  SAVE_PRE_SUCCESS,
  //
  TOGGLE_PRE_MODAL,
} from "./constants";

export const getPreData = (payload) => ({
  type: GET_PRE_DATA,
  payload,
});
export const getPreDataSuccess = (payload) => ({
  type: GET_PRE_DATA_SUCCESS,
  payload,
});
export const getPreDataFailure = (payload) => ({
  type: GET_PRE_DATA_FAILURE,
  payload,
});

export const savePre = (payload, onSave) => ({
  type: SAVE_PRE,
  payload,
  onSave,
});
export const savePreSuccess = (payload) => ({
  type: SAVE_PRE_SUCCESS,
  payload,
});
export const savePreFailure = (payload) => ({
  type: SAVE_PRE_FAILURE,
  payload,
});

export const togglePreModal = (payload) => ({
  type: TOGGLE_PRE_MODAL,
  payload,
});
